import { Provider } from '@angular/core';
import { RouteReuseStrategy as AngularRouteReuseStrategy } from '@angular/router';
import { RouteReuseStrategy } from './route-reuse.strategy';

export const ROUTE_PROVIDERS: Provider[] = [
  { provide: AngularRouteReuseStrategy, useClass: RouteReuseStrategy },
];
